"use strict";
import { useCallback } from "react";
import { useAddPopup, useRemovePopup } from "state/application/hooks";
import { PopupType } from "state/application/reducer";
import { SwapTab } from "uniswap/src/types/screens/interface";
export function useShowSwapNetworkNotification() {
  const addPopup = useAddPopup();
  const removePopup = useRemovePopup();
  return useCallback(
    ({ chainId, prevChainId, outputChainId }) => {
      if (!chainId || chainId === prevChainId || chainId === outputChainId) {
        return;
      }
      const isBridgeNotification = chainId && outputChainId;
      removePopup(`switchNetwork-${prevChainId}`);
      if (isBridgeNotification) {
        addPopup(
          {
            type: PopupType.Bridge,
            inputChainId: chainId,
            outputChainId
          },
          `bridge-${chainId}-to-${outputChainId}`,
          3e3
        );
      } else if (prevChainId) {
        addPopup(
          {
            type: PopupType.SwitchNetwork,
            chainId,
            action: SwapTab.Swap
          },
          `switchNetwork-${chainId}`,
          3e3
        );
      }
    },
    [addPopup, removePopup]
  );
}
